import RequestsContainer from './RequestsContainer.jsx';
import RequestDetail from './RequestDetail.jsx';

export {RequestsContainer, RequestDetail}



// WEBPACK FOOTER //
// ./pages/requests/index.js